// libs
import { Spinner } from 'ui-components';
// Apps
import styles from './fullpage-spinner.module.scss';

/**
 * Displays a spinner centered vertically and horizontally in the page
 */
const FullpageSpinner = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
};

export default FullpageSpinner;
